import { render, staticRenderFns } from "./SidebarContext.vue?vue&type=template&id=3255d764&scoped=true"
import script from "./SidebarContext.vue?vue&type=script&lang=ts"
export * from "./SidebarContext.vue?vue&type=script&lang=ts"
import style0 from "./SidebarContext.vue?vue&type=style&index=0&id=3255d764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3255d764",
  null
  
)

export default component.exports